<template>
  <div>
    <div class="row">
      <div class="col-6">
        <label for="RaisedDate" class="d-block">
          Reason For Return
          <b-form-select 
            v-model="ReturnReason" 
            type="text" 
            class="d-block" 
          >
            <option v-for="r in returnReasons" :key="r.value" :value="r.value">{{ r.label }}</option>
          </b-form-select>
        </label>
      </div>
      <div class="col-6">
        <label for="ContactDate" class="d-block">
          Contact Date
          <el-date-picker
            id="ContactDate"
            v-model="CustomerContactDate"
            format="dd.MM.yyyy"
            value-format="yyyy-MM-dd"
            class="float-right"
            type="date"
            placeholder="Select"
          ></el-date-picker>
        </label>
      </div>
    </div>

    <div class="row">
      <!-- <div class="col-6">
        <label for="InitatingSupplier" class="d-block">
          Initating Supplier
          <b-form-input  type="text" disabled/>
        </label>
      </div> -->
      <div class="col-6">
        <label for="AssociatedSupplier" class="d-block">
          Associated Supplier
          <b-form-input v-model="AssociatedSupplier" type="text" disabled/>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="GainingSupplier" class="d-block">
          Gaining Supplier
          <b-form-input v-model="GainingSupplier" type="text" disabled/>
        </label>
      </div>
      <div class="col-6">
        <label for="LosingSupplier" class="d-block">
          Losing Supplier
          <b-form-input v-model="LosingSupplier" type="text" disabled/>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="CustomerName" class="d-block">
          Customer Name
          <b-form-input v-model="form.CustomerName" type="text" disabled/>
        </label>
      </div>
      <div class="col-6">
        <label for="Telephone" class="d-block">
          Telephone
          <b-form-input v-model="form.CustomerTelephone" type="text" disabled/>
        </label>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label for="SSD" class="d-block">
          SSD
          <b-form-input v-model="registration.from" type="text" disabled/>
        </label>
      </div>
      <div class="col-6">
        <label for="SED" class="d-block">
          SED
          <b-form-input v-model="registration.to" type="text" disabled/>
        </label>
      </div>
    </div>
    
    <div class="row">
      <div class="col">
        <label for="AdditionalInformation" class="d-block">
          Additional Information
          <textarea 
            id="AdditionalInformation"
            v-model="AdditionalInformation" 
            name="AdditionalInformation"
            class="form-control additional-info-textarea"
            rows="6" 
            :placeholder="additionalInfoPlaceholder"
            :aria-describedby="additionalInfoHelpId"
            @keydown="preventLineBreaksInAdditionalInfo"
          ></textarea>
          <small 
            :id="additionalInfoHelpId" 
            class="form-text text-muted"
          >
            Line breaks are not allowed and will be converted to spaces to ensure flow compatibility.
          </small>
        </label>
      </div>
    </div>

    <div>
      <input v-model="NoContact" type="checkbox" name="NoContact" id="" class="mr-3" >
      No Contact
    </div>
    

    <div class="row mt-3">
      <div class="col-auto">
        <button class="btn btn-hc" :disabled="
          !CustomerContactDate 
          || !ReturnReason
        "
        data-dismiss="modal"
        @click="submit"
        >Submit</button>
      </div>

      <div class="col-auto">
                <button class="btn"
                data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EtCreateElectricity',

  props: ['tenancy', 'customer', 'registration'],

  data() {
    return {
      CustomerContactDate: undefined,
      NoContact: undefined,
      ReturnReason: undefined,
      AdditionalInformation: undefined,
    };
  },

  computed: {
    form() {
      return {
        RegistrationSharedId: this.registration.sharedId,
        CustomerContactDate: this.CustomerContactDate,
        CustomerName: this.customer && this.customer.CustomerName,
        CustomerTelephone:
          this.customer &&
          (this.customer.PrimaryContact.Landline ||
            this.customer.PrimaryContact.Mobile),
        NoContact: !!this.NoContact,
        ReturnReason: this.ReturnReason,
        Status:
          this.registration.to == 'Ongoing' ? 'ProposedByNew' : 'ProposedByOld',
        AdditionalInformation: this.AdditionalInformation,
      };
    },

    returnReasons() {
      return [
        { label: 'Forgery', value: 'Forgery' },
        { label: 'Misled', value: 'Misled' },
        {
          label: 'Cancelled Contract Not Actioned',
          value: 'CancelledNotActioned',
        },
        { label: 'Incorrect MPAN', value: 'IncorrectMpan' },
        {
          label: 'Customer Service Returner',
          value: 'CustomerServiceReturner',
        },
        { label: 'Technical Issues ', value: 'TechnicalIssues' },
      ];
    },

    RaisedDate() {
      return new Date();
    },

    Supplier() {
      return this.registration && this.registration.supplierId;
    },

    AssociatedSupplier() {
      if (!this.registration) return 'N/A';

      return this.registration.to == 'Ongoing'
        ? this.registration.gainedFromId
        : this.registration.lostToId;
    },

    LosingSupplier() {
      return this.registration.to == 'Ongoing'
        ? (this.registration && this.registration.gainedFromId) || 'N/A'
        : (this.registration && this.registration.elecSupplierId) || 'N/A';
    },

    GainingSupplier() {
      return this.registration.to == 'Ongoing'
        ? (this.registration && this.registration.elecSupplierId) || 'N/A'
        : (this.registration && this.registration.lostToId) || 'N/A';
    },

    /**
     * Computed properties for UI text and IDs to improve maintainability
     */
    additionalInfoPlaceholder() {
      return 'Enter additional information (single line only)';
    },

    additionalInfoHelpId() {
      return 'additional-info-help-text';
    },
  },

  methods: {
    /**
     * Prevents line breaks in Additional Information textarea to ensure flow compatibility
     * 
     * Business Context:
     * - Erroneous Transfer flows are sent as structured data files
     * - Line breaks in the Additional Information field cause parsing errors in the flow system
     * - This prevents flow processing failures and ensures data integrity
     * 
     * Technical Implementation:
     * - Intercepts Enter key presses and converts them to spaces
     * - Maintains cursor position for good UX
     * - Preserves all other keyboard functionality
     * 
     * @param {KeyboardEvent} event - The keyboard event from the textarea
     */
    preventLineBreaksInAdditionalInfo(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.insertSpaceAtCursor(event.target);
      }
    },

    /**
     * Inserts a space at the current cursor position in a textarea
     * Helper method to keep the main event handler clean and testable
     * 
     * @param {HTMLTextAreaElement} textarea - The textarea element
     */
    insertSpaceAtCursor(textarea) {
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const currentValue = this.AdditionalInformation || '';
      
      // Insert space at cursor position (or replace selected text with space)
      this.AdditionalInformation = 
        currentValue.substring(0, start) + ' ' + currentValue.substring(end);
      
      // Restore cursor position after the inserted space
      this.$nextTick(() => {
        textarea.setSelectionRange(start + 1, start + 1);
      });
    },

    submit() {
      this.$emit('submit', this.form);

      this.CustomerContactDate = undefined;
      this.NoContact = undefined;
      this.ReturnReason = undefined;
      this.AdditionalInformation = undefined;
    },
  },
};
</script>

<style scoped>
label {
  white-space: nowrap;
}

.additional-info-textarea {
  width: 100%;
  resize: vertical;
  font-family: inherit;
}

.additional-info-textarea:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>
